// extracted by css-extract-rspack-plugin
export default {"toggle":"toggle-d5hPwe","notSelect":"notSelect-A8KcJf","optionRow":"optionRow-CA2Ix4","defaultTag":"defaultTag-KIOp0y"};